/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc
 */
import * as References from './HubSpotVideoSearchRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc#search
 */
export const SEARCH_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoSearchRpc_search';
export const SEARCH_QUERY: RegisteredQuery<
  'result',
  References.SearchRequestType,
  References.SearchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: SEARCH_QUERY_FIELD_NAME,
  args: ['count', 'offset', 'filterGroups', 'sorts'],
  fetcher(
    request: References.SearchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SearchResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.searchRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc#advancedSearch
 */
export const ADVANCED_SEARCH_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoSearchRpc_advancedSearch';
export const ADVANCED_SEARCH_QUERY: RegisteredQuery<
  'result',
  References.AdvancedSearchRequestType,
  References.AdvancedSearchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: ADVANCED_SEARCH_QUERY_FIELD_NAME,
  args: ['fileId', 'query', 'topK', 'searchType'],
  fetcher(
    request: References.AdvancedSearchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.AdvancedSearchResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.advancedSearchRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc#advancedSearchWithVideosHydrated
 */
export const ADVANCED_SEARCH_WITH_VIDEOS_HYDRATED_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoSearchRpc_advancedSearchWithVideosHydrated';
export const ADVANCED_SEARCH_WITH_VIDEOS_HYDRATED_QUERY: RegisteredQuery<
  'result',
  References.AdvancedSearchWithVideosHydratedRequestType,
  References.AdvancedSearchWithVideosHydratedResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: ADVANCED_SEARCH_WITH_VIDEOS_HYDRATED_QUERY_FIELD_NAME,
  args: ['fileId', 'query', 'topK', 'searchType'],
  fetcher(
    request: References.AdvancedSearchWithVideosHydratedRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.AdvancedSearchWithVideosHydratedResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.advancedSearchWithVideosHydratedRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc#getEmbeddedVectorsForVideo
 */
export const GET_EMBEDDED_VECTORS_FOR_VIDEO_QUERY_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoSearchRpc_getEmbeddedVectorsForVideo';
export const GET_EMBEDDED_VECTORS_FOR_VIDEO_QUERY: RegisteredQuery<
  'result',
  References.GetEmbeddedVectorsForVideoRequestType,
  References.GetEmbeddedVectorsForVideoResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_EMBEDDED_VECTORS_FOR_VIDEO_QUERY_FIELD_NAME,
  args: ['sourceFileId'],
  fetcher(
    request: References.GetEmbeddedVectorsForVideoRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetEmbeddedVectorsForVideoResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getEmbeddedVectorsForVideoRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc#reprocessVideosForVisualSearch
 */
export const REPROCESS_VIDEOS_FOR_VISUAL_SEARCH_MUTATION_FIELD_NAME =
  'com_hubspot_video_rpc_HubSpotVideoSearchRpc_reprocessVideosForVisualSearch';
export const REPROCESS_VIDEOS_FOR_VISUAL_SEARCH_MUTATION: RegisteredQuery<
  'result',
  References.ReprocessVideosForVisualSearchRequestType,
  References.ReprocessVideosForVisualSearchResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: REPROCESS_VIDEOS_FOR_VISUAL_SEARCH_MUTATION_FIELD_NAME,
  args: ['fileIds'],
  fetcher(
    request: References.ReprocessVideosForVisualSearchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ReprocessVideosForVisualSearchResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.reprocessVideosForVisualSearchRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
